module.exports = __webpack_public_path__ + "6c6700478ea404184397c1b6d9ae8f0d.pdf";